import { useExperimentsTranslations } from 'modules/experiments/hooks';
import { Trophy } from 'modules/experiments/components/ui/icons';

import { WinningBadgeStyle } from './Styled';
import { TextNoWrap } from '../variantTable/cells/Styled';

export const WinningTrophyBadge = () => {
  const { t } = useExperimentsTranslations();
  return (
    <WinningBadgeStyle>
      <Trophy isColorInherited />
      <TextNoWrap>{t('badge.winning')}</TextNoWrap>
    </WinningBadgeStyle>
  );
};
